/**
 * Inquiry Form - Button Validation
 * すべての必須フィールドが入力されたらボタンを有効化
 */

(function() {
  'use strict';

  // お問い合わせフォームが存在しない場合は処理しない
  var inquiryForm = document.querySelector('.inquiry-form');
  if (!inquiryForm) return;

  var submitButton = document.getElementById('inquiry-submit-button');
  if (!submitButton) return;

  // 必須フィールド
  var requiredFields = [
    document.getElementById('inquiry-name'),
    document.getElementById('inquiry-email'),
    document.getElementById('inquiry-phone'),
    document.getElementById('inquiry-body')
  ];

  /**
   * すべての必須フィールドが入力されているかチェック
   */
  function validateForm() {
    var allFilled = true;

    for (var i = 0; i < requiredFields.length; i++) {
      var field = requiredFields[i];
      if (!field || !field.value.trim()) {
        allFilled = false;
        break;
      }
    }

    // ボタンの状態を更新
    if (allFilled) {
      submitButton.classList.remove('bg-[#e6e3e6]');
      submitButton.classList.add('bg-[#5b295c]', 'hover:bg-[#4a1f4a]');
    } else {
      submitButton.classList.remove('bg-[#5b295c]', 'hover:bg-[#4a1f4a]');
      submitButton.classList.add('bg-[#e6e3e6]');
    }
  }

  // 各フィールドの変更を監視
  for (var i = 0; i < requiredFields.length; i++) {
    var field = requiredFields[i];
    if (field) {
      field.addEventListener('input', validateForm);
      field.addEventListener('change', validateForm);
    }
  }

  // 初期状態をチェック
  validateForm();

})();
